import PackageJson from '../../package.json'

export const getPackageInfo = async () => {
  return PackageJson
}
